import React from 'react';
import '../styles.css';
import { useSelector, useDispatch } from 'react-redux';
import { HIDDEN, FADE } from '../../HOME/const';
import HelpIcon from '../../HOME/SVG/HelpIcon';
import ResetStatsIcon from '../../HOME/SVG/ResetStatsIcon';
import VolumeControl from '../../HOME/COMPONENTS/VolumeControl';
import { REQUEST_RESET_STATS_ON, GOTO_HELP_FROM_GAME_PAGE } from '../../HOME/REDUX/actions';

const Options = props => {
  const dispatch = useDispatch();
  const cm = useSelector(state => state.cm);

  const handleResetStats = e => {
    if (canResetStats()) {
      props.hideOptions();
      dispatch(REQUEST_RESET_STATS_ON);
    }
  };

  const canResetStats = () => {
    const { stats } = cm;
    return stats && stats.plays > 0;
  };

  const handleHelp = () => {
    props.hideOptions();
    dispatch(GOTO_HELP_FROM_GAME_PAGE);
  };

  const { op } = props;
  const optionsVisibility = op === HIDDEN ? 'none' : 'inline';

  return (
    <div className={`options ${op === FADE ? 'fadeout' : 'fadein-fast'}`} style={{ display: optionsVisibility }}>
      <div className="options-x" onClick={props.hideOptions}>
        ×
      </div>
      <div className={`options-item${canResetStats() ? '' : ' options-item-disabled'}`} onClick={handleResetStats}>
        <ResetStatsIcon width="30" />
        <span>reset stats</span>
      </div>
      <div className="options-item" onClick={handleHelp}>
        <HelpIcon width="30" />
        <span>how to play</span>
      </div>
      <VolumeControl />
    </div>
  );
};

export default Options;
